import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_LIVES = "fetchCompanyLives";

// mutation types
export const SET_COMPANY_LIVES = "setCompanyLives";
export const SET_COMPANY_LIVES_PAGINATION = "setCompanyLivesPagination";
export const SET_COMPANY_LIVES_STATICS = "setCompanyLivesStatics";

const state = {
  companyLives: [],
  companyLivesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  companyLivesStatics: {
    failed: 0,
    length: 0,
    visitors_count: 0,
    users: 0,
    started: 0,
    stopped: 0,
    stopped_by_operator: 0,
    stopped_by_company: 0,
    stopped_by_user: 0
  }
};

const getters = {
  companyLives(state) {
    return state.companyLives;
  },
  companyLivesPagination(state) {
    return state.companyLivesPagination;
  },
  companyLivesStatics(state) {
    return state.companyLivesStatics;
  }
};

const actions = {
  [FETCH_COMPANY_LIVES](context, payload) {
    let params = {
      page: context.state.companyLivesPagination.currentPage
    };
    if (payload.status !== undefined) {
      params.status = payload.status;
    }
    if (payload.from) {
      params.from = payload.from || new Date();
    }
    if (payload.to) {
      params.to = payload.to || new Date();
    }
    if (payload.statics !== undefined) {
      params.statics = payload.statics;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("company/lives", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_LIVES, data.lives.data);
          context.commit(SET_COMPANY_LIVES_PAGINATION, {
            total: data.lives["total"],
            currentPage: data.lives["current_page"],
            firstPage: data.lives["first_page"],
            lastPage: data.lives["last_page"],
            perPage: data.lives["per_page"]
          });
          context.commit(SET_COMPANY_LIVES_STATICS, data.statics);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_LIVES](state, payload) {
    state.companyLives = payload;
  },
  [SET_COMPANY_LIVES_PAGINATION](state, data) {
    state.companyLivesPagination = data;
  },
  [SET_COMPANY_LIVES_STATICS](state, data) {
    state.companyLivesStatics = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
